module.exports = __webpack_public_path__ + "img/mobile-neck-1_26x418.203a0395.png";